import { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CONTACT, PIPELINE, CUSTOM_OBJECT } from './helpers';
import { getCreateEntityAccess } from 'store/authentication/selectors';

export const useEntityCreationModal = (field = {}) => {
  const [initialValues, setInitialValues] = useState({});
  const createEntityAccess = useSelector(getCreateEntityAccess);
  const parseTypeAhead = useCallback((val, isContact) => {
    if (!isContact) {
      setInitialValues({ name: val });
    } else {
      const isEmail = val.includes('@');
      if (isEmail) {
        setInitialValues({ email: val, first_name: val.split('@')[0] });
      } else {
        const stringArr = val.split(' ');
        setInitialValues(
          stringArr.length > 1
            ? { first_name: stringArr[0], last_name: stringArr[1] }
            : { first_name: stringArr[0] }
        );
      }
    }
  }, []);

  const objectType = useMemo(() => {
    if (field.relation?.fetchUrl === 'pipeline') return PIPELINE;
    if (field.relation?.fetchUrl === 'standard') return CUSTOM_OBJECT;

    return CONTACT;
  }, [field]);

  const hasAbilityToAdd = useMemo(() => {
    return createEntityAccess[field.relation?.relatedObject];
  }, [field.relation?.relatedObject, createEntityAccess]);

  return {
    initialValues,
    setInitialValues,
    parseTypeAhead,
    objectType,
    hasAbilityToAdd,
  };
};
